// Core GTM Data Layer utilities

/**
 * Check if GTM is enabled (container ID was provided)
 */
export function isGTMEnabled(): boolean {
  return typeof window !== 'undefined' && window.__GTM_ENABLED__ === true;
}

/**
 * Push data to the dataLayer
 */
export function pushToDataLayer(data: Record<string, unknown>): void {
  if (!isGTMEnabled()) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

/**
 * Push an ecommerce event with automatic ecommerce clearing
 * Uses GA4 recommended pattern of clearing ecommerce before pushing new data
 */
export function pushEcommerceEvent(eventName: string, ecommerceParams: Record<string, unknown>): void {
  if (!isGTMEnabled()) return;

  window.dataLayer = window.dataLayer || [];

  // Clear previous ecommerce data and push new event in one operation
  // This prevents "data bleed" between events
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: eventName,
    ecommerce: ecommerceParams,
  });
}

/**
 * Push a custom event (non-ecommerce)
 */
export function pushEvent(eventName: string, params?: Record<string, unknown>): void {
  pushToDataLayer({
    event: eventName,
    ...params,
  });
}

/**
 * Push virtual pageview with page dimensions
 */
export function pushVirtualPageview(pagePath: string, pageTitle: string, dimensions?: Record<string, unknown>): void {
  pushToDataLayer({
    event: 'virtualPageview',
    pagePath,
    pageTitle,
    ...dimensions,
  });
}
